export const BLOCK_TYPE_TEXT = 'textSection';
